import React from "react";
import "./footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container footer__grid">
        <div className="footer__brand">
          <a href="#home" className="footer__logo">
            <span className="footer__mark">MZ</span>
            Mustafa Zeb
          </a>
          <p>
            React Native developer & IT project manager building mobile, web,
            and desktop products in Riyadh.
          </p>
          <p className="footer__place">Riyadh, Saudi Arabia · AST · UTC+3</p>
        </div>

        <nav aria-label="Footer">
          <h2>Navigate</h2>
          <ul>
            <li><a href="#work">Work</a></li>
            <li><a href="#about">About</a></li>
            <li><a href="#experience">Experience</a></li>
            <li><a href="#skills">Skills</a></li>
            <li><a href="#background">Background</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </nav>

        <div>
          <h2>Elsewhere</h2>
          <ul>
            <li><a href="mailto:mustafazeb381@gmail.com">Email</a></li>
            <li>
              <a href="https://github.com/mustafazeb381-123/" target="_blank" rel="noreferrer">
                GitHub
              </a>
            </li>
            <li>
              <a href="https://www.linkedin.com/in/mustafa-zeb-72a180172" target="_blank" rel="noreferrer">
                LinkedIn
              </a>
            </li>
            <li>
              <a href="https://api.whatsapp.com/send?phone=966503111669" target="_blank" rel="noreferrer">
                WhatsApp
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="container footer__bottom">
        <small>&copy; {new Date().getFullYear()} Mustafa Zeb. All rights reserved.</small>
        <small>Built with React.js</small>
      </div>
    </footer>
  );
};

export default Footer;
